import React, { useEffect, useRef, useState } from "react";
import "./Navbar.scss";
import Menu from "../Menu/Menu";
import { IoChevronDownSharp } from "react-icons/io5";
import useFetch from "../../hooks/useFetch";
import logo from "../../assets/logo_prod.png";
import { BASE_URL } from "../../utils/config";
import { adminRequest } from "../../utils/requestMethods";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef();
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsMenuOpen(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const { data } = useFetch(`${BASE_URL}/user/profile`, adminRequest);
  return (
    <div className="navbarContainer">
      <div className="logoContainer">
        <div className="left">
          <img src={logo} alt="" className="logoImg" />
        </div>
      </div>
      <div className="profileContainer" onClick={toggleMenu} ref={menuRef}>
        <div className="profile">
          <img
            src="https://i.pinimg.com/736x/8b/16/7a/8b167af653c2399dd93b952a48740620.jpg"
            alt="profile"
            className="profileImg"
          />
          <span className="profileName">
            Namaste, {data && data.data ? data.data.fullName : ""}
          </span>
          <span className="chevron">
            <IoChevronDownSharp />
          </span>
        </div>
        {isMenuOpen && <Menu />}
      </div>
    </div>
  );
};

export default Navbar;
